export const RESET = 'EXSBWAREHOUSE_LIST_RESET'
export const SET_ITEMS = 'EXSBWAREHOUSE_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBWAREHOUSE_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBWAREHOUSE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBWAREHOUSE_LIST_TOGGLE_LOADING'
